import React from 'react';
// import PropTypes from 'prop-types';
// import { at } from 'lodash';
// import { useField } from 'formik';
import {
  InputLabel,
  FormControl,
  Select,
  MenuItem,
  FormHelperText,
  FormControlLabel,
  RadioGroup,
  Radio,
} from '@mui/material';

export const RadioFieldRHFRow = ({
  name,
  label,
  options,
  isDisabled,
  rhf: { control, Controller },
  error,
}) => {
  //
  const generateRadioOptions = () => {
    return options.map((singleOption) => (
      <FormControlLabel
        disabled={isDisabled}
        value={singleOption.value}
        label={singleOption.label}
        control={
          <Radio
            sx={{
              '& .MuiSvgIcon-root': {
                marginLeft: 6,
              },
            }}
          />
        }
      />
    ));
  };

  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <RadioGroup 
            row 
            value={field.value || ''} 
            onChange={field.onChange}
            sx={{ pl: 2 }}
          >
            {generateRadioOptions()}
          </RadioGroup>
        )}
      />
      <FormHelperText error={error}>
        {error ? '(' + error.message + ')' : ''}
      </FormHelperText>
      {/* <small className="text-danger">
        {errors?.role && errors.role.message}
      </small> */}
    </>
  );
};

// SelectField.defaultProps = {
//   data: [],
// };

// SelectField.propTypes = {
//   data: PropTypes.array.isRequired,
// };

export default RadioFieldRHFRow;
